import {
    GET_TERMS_CONDITIONS_LIST_PROGRESS, GET_TERMS_CONDITIONS_LIST_SUCCESS, GET_TERMS_CONDITIONS_LIST_FAILURE,
    ADD_TERMS_CONDITIONS_PROGRESS, ADD_TERMS_CONDITIONS_SUCCESS, ADD_TERMS_CONDITIONS_FAILURE,
    EDIT_DELETE_TERMS_CONDITIONS_PROGRESS, EDIT_DELETE_TERMS_CONDITIONS_SUCCESS, EDIT_DELETE_TERMS_CONDITIONS_FAILURE,
   
    RESET_MESSAGE,

} from '../types/actionTypes';

const initialState = {
    termsConditions: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const terms_conditions_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TERMS_CONDITIONS_LIST_SUCCESS:
            return { ...state, termsConditions: action.termsConditions, loading: false };
        case GET_TERMS_CONDITIONS_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_TERMS_CONDITIONS_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_TERMS_CONDITIONS_PROGRESS:
            return { ...state, loading: true };
        case ADD_TERMS_CONDITIONS_SUCCESS:
            return { ...state, termsConditions: [...state.termsConditions, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_TERMS_CONDITIONS_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_TERMS_CONDITIONS_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_TERMS_CONDITIONS_SUCCESS:
            return {
                ...state,
                termsConditions: state.termsConditions.map((termsConditions) =>
                termsConditions.id === action.payload.id ? action.payload : termsConditions
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_TERMS_CONDITIONS_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
     
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default terms_conditions_reducer;